import { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
//import IdleTimer from 'react-idle-timer';
import { useIdleTimer } from 'react-idle-timer'
import SweetAlert from "sweetalert2";
import IdleTimer from 'react-idle-timer';

import { RequireAuth, useAuthHeader, useAuthUser, useIsAuthenticated, useSignOut } from '../Services/Auth/sessionAuth';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import User from '../Components/Forms/ManageUser/User';
import { t } from 'i18next';
import Groupe from '../Components/Forms/ManageGoupe/Groupe';
import PageNotFound from './PageNotFound';
import Simulation from '../Components/Forms/Pret/SimulationManage/Simulation';
import PrintTabAmort from '../Components/Prints/PrintTabAmort';
import DemandePret from '../Components/Forms/Pret/PretManage/DemandePret';
import Garantie from '../Components/Forms/GarantieManage/Garantie';
import ClientPhys from '../Components/Forms/ClientPysique/ClientPhysique';
import ClientMoral from '../Components/Forms/ClientMoral/ClientMoral';
import AddLimite from '../Components/Forms/Limite/AddLimite';
import Avaliste from '../Components/Forms/AvalisteManage/Avaliste';
import Relation from '../Components/Forms/Relation/Relation';
import ClientInterne from '../Components/Forms/ClientInterne/ClientInterne';
import CompteOrd from '../Components/Forms/ComptesOrdinaire/CompteOrd';
import Procuration from '../Components/Forms/Procuration/Procuration';
import CompteE from '../Components/Forms/CompteE/CompteGE1';
import CompteGl from '../Components/Forms/CompteGl/CompteGl1';
import AddAutorisation from '../Components/Forms/AutorisationDemand/AddAuto/AddAutorisation';
import InvalidAutorisation from '../Components/Forms/AutorisationDemand/InvalidAuto/InvalidAutorisation';
import ValidAutor from '../Components/Forms/AutorisationDemand/ValidAuto/ValidAutor';
import HistoAutorisation from '../Components/Forms/AutorisationDemand/HistoAuto/HistoAutorisation';
import VisualAutor from '../Components/Forms/AutorisationDemand/VisualAuto/VisualAutor';
import Dashbord from '../Components/Dashbord';
import AddBlocage from '../Components/Forms/BlocageComptes/AddBlocage/AddBlocage';
import ValidBlocage from '../Components/Forms/BlocageComptes/ValidBlocage/ValidBlocage';
import AnnulBlocage from '../Components/Forms/BlocageComptes/AnnulBlocage/AnnulBlocage';
import VClientPhysique from '../Components/Forms/VClientPysique/VClientPhysique';
import VisualBlocage from '../Components/Forms/BlocageComptes/VisualBlocage/VisualBlocage';
import ControlCpt from '../Components/Forms/ControlCpt/ControlCpt';

import SituationCLient from '../Components/Forms/SituationCLient/SituationCLient';
import DemandCHQ from '../Components/Forms/GestChequier/DemandCheque/DemandCheque';
import CreateCHQ from '../Components/Forms/GestChequier/CreateCheque/CreateCHQ';
import ValidCheque from '../Components/Forms/GestChequier/ValidCheque/ValidCheque';
import OppositionCheque from '../Components/Forms/GestChequier/OppositionCheque/OppositionCheque';
import AnnulOpposition from '../Components/Forms/GestChequier/AnnulOppoCHQ/AnnulOpposition';
import VisualCheque from '../Components/Forms/GestChequier/VisualCheque/VisualCheque';
import VClientMoral from '../Components/Forms/ValidClientMoral/VClientMoral';
import LogoAnyBank from '../Res/LogoAnyBank.svg';
import PropositionPret from '../Components/Forms/Pret/PropositionManage/PropositionPret';
import DecaissementPret from '../Components/Forms/Pret/DecaissementManage/DecaissementPret';
import ValidationPret from '../Components/Forms/Pret/ValidationManage/ValidationPret';
import AnticipationPret from '../Components/Forms/Pret/AnticipationManage/AnticipationPret';
import DeclassementPret from '../Components/Forms/Pret/DeclassementManage/DeclassementPret';
import AddVp from '../Components/Forms/VirementPermanent/AddVP/AddVp';
import ClotureVp from '../Components/Forms/VirementPermanent/ClotureVp/ClotureVP';
import OpposeVP from '../Components/Forms/VirementPermanent/OpposeVP/Oppose';
import ValidEInvalidVp from '../Components/Forms/VirementPermanent/ValidVp/ValidEInvalidVp';
import VisualVp from '../Components/Forms/VirementPermanent/VisualVp/VisualVp';
import OuvertureFermetureCaisse from '../Components/Forms/OperationCaisseManage/JourneeCaisse/OuvertureFermetureCaisse';
import VersementEspece from '../Components/Forms/OperationCaisseManage/VersementEspeceManage/VersementEspece';
import EchangeManuelleCaisse from '../Components/Forms/OperationCaisseManage/EchangeManuelleCaisse/EchangeManuelleCaisse';
import TransfertCptToCpt from '../Components/Forms/Operations/Virement/TransfertCptToCpt/TransfertCptCpt/TransfertCptToCpt';
import BackOffice from '../Components/Forms/Operations/SaisieBackOffice/BackOffice';
import PrintHistoCpt from '../Components/Prints/PrintHistoCpt';
import PrintAvisOp from '../Components/Prints/PrintAvisOp';
import PrintShemaComptable from '../Components/Prints/PrintShemaComptable';
import ImportSaisie from '../Components/Forms/Operations/ImportSaisie/ImportSaisie';
import Extourne from '../Components/Forms/Operations/Extourne/Extourne';

import ValideOperation from '../Components/Forms/Operations/ValideOperation/ValideOperation';
import ValidationOperation from '../Components/Forms/OperationCaisseManage/ValidationOperation/ValidationOperation';
import ReimpressionRecu from '../Components/Forms/ReimpressionRecu/ReimpressionRecu';
import PrintRecu from '../Components/Prints/PrintRecu';
import Saisie from '../Components/Forms/GestChequier/Remisecheque/Saisie/Saisie';
import RemiseBank from '../Components/Forms/GestChequier/Remisecheque/RemiseBank/RemiseBank';
import BackToBank from '../Components/Forms/GestChequier/Remisecheque/bankCheckBack/BackToBank';
import EstCompte from '../Components/Forms/GestChequier/Remisecheque/EstComptes/EstCompte';
import CloseDay from '../Components/Forms/Business/CloseDay/CloseDay';
import OpenDay from '../Components/Forms/Business/OpenDay/OpenDay';
import PlanCp from '../Components/Forms/PlanCp/PlanCp';
import PlanCpBatch from '../Components/Forms/PlanCp/PlanCpBatch';
import EmissionReceptionFond from '../Components/Forms/OperationCaisseManage/EmissionReceptionFond/EmissionReceptionFond';
import ArreterCaisse from '../Components/Forms/OperationCaisseManage/ArreterCaisse/ArreterCaisse';
import PrintClotureSystemCaisse from '../Components/Prints/PrintClotureSystemCaisse';
import ManageSystemeCaisse from '../Components/Forms/OperationCaisseManage/ManageSystemeCaisse/ManageSystemeCaisse';
import PrintEtatCaisse from '../Components/Prints/PrintEtatCaisse';
import { Backdrop, CircularProgress } from '@mui/material';
import axios from 'axios';
import { MenuAppbar } from '../Components/Appbar';
import CalInteret from '../Components/Forms/Business/CalInteret/CalInteret';
import Commis from '../Components/Forms/Commis/Commis';
import CompteRegroup from '../Components/Forms/ComptesRegroupes/CompteRegroup';
import CreateBank from '../Components/Forms/CreateBanque/CreateBank';
import CreateFerier from '../Components/Forms/CreateFerier/CreateFerier';
import CreateService from '../Components/Forms/CreateService/CreateService';
import CreateVille from '../Components/Forms/CreateVille/CreateVille';
import CreateCaisse from '../Components/Forms/CreationCaisse/CreateCaisse';
import GestionBudget from '../Components/Forms/GestionBudgetaire/GestionBudget';

import Habilitation from '../Components/Habilitation';
import PrintINTDEB from '../Components/Prints/PrintIntDeb';
import { Crypter } from '../Functions/Security/Crypter';
import Utilisateur from '../Models/Utilisateur';
import Data from "./../Data/Data.json";
import ImputInteret from '../Components/Forms/Business/ImputInteret/ImputInteret';
import ListingCaisse from '../Components/Forms/Listing/ListingCaisse/ListingCaisse';
import OperaSysteme from '../Components/Forms/OperaSysteme/OperaSysteme';
import Operation from '../Components/Forms/Operation/Operation';
import Agence from '../Components/Forms/Agence/Agence';

import VisualLimite from '../Components/Forms/Limite/Visualisation/VisualLimite';
import Menu from '../Models/Menu';
import Logout from '../Services/User/Logout';
import AddAutorisation2 from '../Components/Forms/AutorisationDemand/AddAuto2/AddAutorisation2';
import Historique from '../Components/Forms/HistoriqueGL/Historique';
import PrintListOpeCai from '../Components/Prints/PrintListOpeCai';
import ListComptabilise from '../Components/Forms/Listing/ListComptabilise/ListComptabilise';
import PrintListOpeCm from '../Components/Prints/PrintListOpeCm';
import ListNonComptabilise from '../Components/Forms/Listing/ListNonComptabilise/ListNonComptabilise';
import Socity from '../Components/Forms/Socity/Socity';
import Rapports from '../Components/rapports';
import ListClientFastReport from '../rapports/ListClientFastReport';
import ListClientFRGroupe from '../rapports/ListClientFRGroupe';
import ListCompteFRGroupe from '../rapports/ListCompteFRGroup';
import FRHistoCompte from '../rapports/FRHistoCompte';
import FRTransactionCaisse from '../rapports/FRTransactionCaisse';
import FRTransactionBackOffice from '../rapports/FRTransactionBackOffice';
import FRTransactionByRef from '../rapports/FRTransactionByRef';
import FRListingPret from '../rapports/FRListingPret';
import FRBalanceCompte from '../rapports/FRBalanceCompte';
import FRSoldeGestion from '../rapports/FRSoldeGestion';
import FRBilanGeneral from '../rapports/FRBilanGeneral';
import ParametreClient from '../Components/Forms/ParametreClient/ParametreClient';
//import FormatCompte from '../Components/Forms/FormatCompte/FormatCompte1';
import FormatCompte1 from '../Components/Forms/FormatCompte/FormatCompte1';
import ComptesCommis from '../Components/Forms/ComptesCommis/ComptesCommis';
import ComptesOperatSysteme from '../Components/Forms/ComptesOperatSysteme/ComptesOperatSysteme';
import ComptesPretEtDecouvert from '../Components/Forms/ComptesPretEtDecouvert/ComptesPretEtDecouvert';
import ValidationGarantie from '../Components/Forms/ValidationGarantie/ValidationGarantie';
import BackOfficeInterAgence from '../Components/Forms/BackOfficeInterAgence/BackOfficeInterAgence';
import TransfertCptToCptDistant from '../Components/Forms/VirementDistant/TransfertCptToCptDistant';
import ImportSaisieDistant from '../Components/Forms/ImportSaisieDistant/ImportSaisieDistant';
import ParamBDC from '../Components/Forms/ParamBDC/ParamBDC';
import MfaPage from '../Components/Mfa/MfaPage';
import SocietePage from '../Components/Mfa/SocietePage';
import SimulationBDC from '../Components/Forms/BonDeCaisse/SimulationBDC';
import SimulationBDC2List from '../Components/Forms/BonDeCaisse/SimulationBDC2List';
import CreationBDC from '../Components/Forms/BonDeCaisse/CreationBDC';
import ValidationBDC from '../Components/Forms/BonDeCaisse/ValidationBDC';
import VisualisationBDC from '../Components/Forms/BonDeCaisse/VisualisationBDC';
import AnticipationBDC from '../Components/Forms/BonDeCaisse/AnticipationBDC';
import ListingLitigeCaisse from '../Components/Forms/Listing/ListingLitigeCaisse/ListingLitigeCaisse';
import CreateRoleForm from '../Components/Forms/Roles/CreateRoleForm';
import GroupUser22Page from '../Components/Forms/GroupUser22/GroupUser22Page';
import MenuTree from '../Components/Forms/MenuTree/MenuTree';
import DocumentCleint from '../Components/Forms/DocumentClient/DocumentClient';
import Document from '../Components/Forms/Documents/Document';
import { DarkMode, Start } from '@mui/icons-material';
import Typegarantie from '../Components/Forms/Typegarantie/Typegarantie';
import BilletageConfig from '../Components/Forms/Billetage/BilletageConfig';
import CategorieActifPage from '../Components/Forms/CategorieActif/CategorieActif';
import FormatSMSManage from '../Components/Forms/FormatSMS/FormatSMSManage';
import PointStockagePage from '../Components/Forms/PointStockage/PointStockage';
import JournalFinancementPage from '../Components/Forms/JournalFinancement/Journal';
import FournisseurPage from '../Components/Forms/Fournisseur/Fournisseur';
import ClosingBatch from '../Components/Forms/Business/ClosingBatch/ClosingBatch';
import Fonctionnalite from '../Components/Forms/Fonctionnalite/Fonctionnalite';
import ImportPCEMF from '../Components/Forms/PCEMF/ImportPCEMF';


const drawerWidth = 257;


interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  windows?: () => Window;
}


export default function Home(props: Props) {
  const { windows } = props;
  const auth = useAuthUser()
  const user: Utilisateur & { role?: string; Role?: string } = JSON.parse(JSON.stringify(auth()))
  const signOut = useSignOut()
  const [mobileOpen, setMobileOpen] = useState(false);
  const [state, setState] = useState<string>('Active')
  const [count, setCount] = useState<number>(0)
  const [remaining, setRemaining] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [menus, setMenus] = useState<Menu[]>([]);
  const [pageIsLoad, setPageIsLoad] = useState(true);
  const [tabCount, setTabCount] = useState(1);
  const [DureVeille, setDureVeille] = useState();




  // const handleOnIdle = () => {

  //   const broadcastChannel = new BroadcastChannel('beforeunload');
  //   broadcastChannel.postMessage({ action: 'decrement' });
  // };

  // useEffect(() => {
  //   const broadcastChannel = new BroadcastChannel('tabCountBroadcastChannel' );
  //   broadcastChannel.postMessage({ action: 'increment' });

  //   broadcastChannel.onmessage = (event) => {
  //     if (event.data.action === 'increment') {
  //       setTabCount((prevCount) => prevCount + 1);

  //     } else if (event.data.action === 'decrement') {
  //       setTabCount((prevCount) => prevCount - 1);
  //     }
  //   };

  //   return () => {
  //     broadcastChannel.postMessage({ action: 'decrement' });
  //   };
  // }, []);


  useEffect(() => {
    if (tabCount === 0) {
      LogOut()
      // Déconnecter l'utilisateur lorsque tous les onglets sont fermés
      // Mettre en œuvre la logique de déconnexion ici
      console.log('Déconnexion de l\'utilisateur');
    }
  })


  useEffect(() => {

    GetDureVeille();

    window.addEventListener('beforeunload', LogOut);
    return () => {
      window.removeEventListener('beforeunload', LogOut);
    };
    // Utiliser window ici en toute sécurité

  }, []);


  const LogOut = async () => {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://localhost:7145/Authentification/logout',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
      //data: data
    };

    axios.request(config)
      .then((response) => {
        signOut()
        console.log("OK");
      })
      .catch((error) => {
        console.log("Erreur");
      }
      );
  }

  const GetDureVeille = () => {

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetDureVeille,
      headers: {
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(user.codage),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      }
    };

    axios.request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            // if (res.Result !== '50') {

            setDureVeille(res.Result)
            //   navigate("/");
            // }
          }
          else SweetAlert.fire({ title: "Warning", text: res.Result, icon: "warning" })
        }
      })
      .catch((error) => {
        navigate("/Login");
        SweetAlert.fire({ title: "Warning", text: "Erreur lors de la récupération de la durée de veille", icon: "warning" })
      });

  }


  // USER TOKEN
  const authHeader = useAuthHeader();

  if (pageIsLoad) {

    setPageIsLoad(false)
    loadMenu()
  }


  const onIdle = () => {
    setState('inatif')
    //  handleOnIdle();

    let timerInterval: NodeJS.Timeout;
    SweetAlert.fire({
      title: 'Vous êtes actuellement Inactif!',
      html: 'Vous serez déconnecté automatiquement dans <b></b> milliseconds.',
      timer: 20000,
      showCancelButton: true,
      timerProgressBar: true,
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      icon: 'question',
      didOpen: () => {
        SweetAlert.showLoading()
        const b: any = SweetAlert.getHtmlContainer()?.querySelector('b');
        timerInterval = setInterval(() => {
          if (b) {
            b.textContent = SweetAlert.getTimerLeft()?.toString();
          }
        }, 100)
      },
      willClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === SweetAlert.DismissReason.timer) {
        //
        setLoading(true)
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: 'https://localhost:7145/Authentification/logout',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
          //data: data
        };

        axios.request(config)
          .then((response) => {
            signOut()

            setLoading(false)
          })
          .catch((error) => {
            setLoading(false)
            SweetAlert.fire({
              title: "Déconnexion",
              text: error.message + "",
              icon: 'error',
              cancelButtonColor: "darkred",
              cancelButtonText: "Cloase",
            })
          });
      }
    }).catch(() => {
    })
  }

  const onActive = () => {
    setState('Active')
  }

  const onAction = () => {
    setCount(count + 1)

  }

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: DureVeille,
    throttle: 500
  })



  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000))
    }, 500)

    return () => {
      clearInterval(interval)
    }
  })

  // User session
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate("/login")
    }
  })

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  //lancement 

  const drawer: any = (
    <div id='sidebar' >
      <Link to={"/"}>
        <Stack direction='row' sx={{}} spacing={-10} >
          {/* <Typography sx={{ color: 'green' }}><img src={LogoAnyBank} alt='logo' /></Typography> */}
          {/* <Box bgcolor={"lightblue"} borderRadius={"100%"} width={50} height={50}>.</Box> */}
          <Box display={"flex"}>
            <DarkMode sx={{ color: 'white', fontSize: 50, padding: "40px" }} />
            <Typography id='AnyBank' >{Data.LocalVariable.appName}</Typography>
          </Box>
        </Stack>
      </Link>
      <Divider />
      <List>
        <Habilitation />
      </List>
    </div>
  );

  const container = windows !== undefined ? () => windows().document.body : undefined;

  function loadMenu() {
    console.info('[MENU DEBUG] Home loadMenu start', {
      userCode: user.coduti ?? null,
      groupCode: user.codgroup ?? null,
      endpoint: Data.ApiUrl.userMenus,
    });
    let data = Crypter.encrypt(user.codgroup);
    //console.log(data)

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.userMenus,
      headers: {
        'Authorization': authHeader(),
        'Content-Type': 'application/json',
        "CipherUserGroup": data
      }
    };

    axios
      .request(config)
      .then((response) => {
        console.info('[MENU DEBUG] Home loadMenu response', {
          httpStatus: response.status,
          hasResponseData: Boolean(response.data),
        });
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          console.info('[MENU DEBUG] Home loadMenu business result', {
            status: res?.StatutCode ?? null,
            menuCount: Array.isArray(res?.Result) ? res.Result.length : null,
          });
          if (res.StatutCode == 200) {
            setMenus(Array.isArray(res.Result) ? res.Result : [])
            // sessionStorage.setItem("menu", Crypter.encrypt(JSON.stringify(res.Result)))
          }
          else {
            setMenus([])
          }

        }
      })
      .catch((error) => {
        console.error('[MENU DEBUG] Home loadMenu failed', {
          httpStatus: error?.response?.status ?? null,
          message: error?.message ?? 'unknown error',
        });
      }).finally(() => {
      })
  }

  return (

    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <MenuAppbar />

      <Box
        className='menu'
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box component="main" sx={{ flexGrow: 1, width: { sm: `calc(100% - ${drawerWidth}px)` }, overflowX: 'hidden' }}>
        <Toolbar />
        <Box>
          {/* <IdleTimer ref={IdleTimerRef} timeout={10000} onIdle={onIdle}></IdleTimer> */}
        </Box>
        <Box>

          <Routes>
            <Route path='/' element={
              <RequireAuth loginPath={'/Login'} >
                <Dashbord />
              </RequireAuth>
            }
            />
            <Route path='/mfa/configuration' element={
              <RequireAuth loginPath={'/Login'} >
                <MfaPage isAdmin={String(user.role ?? user.Role ?? user.group ?? user.codgroup ?? '').trim() === '999'} />
              </RequireAuth>
            } />
            <Route path='/configuration/societe' element={
              <RequireAuth loginPath={'/Login'} >
                <SocietePage isAdmin={String(user.role ?? user.Role ?? user.group ?? user.codgroup ?? '').trim() === '999'} />
              </RequireAuth>
            } />
            {
              menus.length != 0 ?
                <>
                  {menus.find((e => e.lien == "/prets/simulation")) ?
                    <>
                      <Route path='/prets/simulation' element={
                        <RequireAuth loginPath={'/Login'} >
                          <Simulation />
                        </RequireAuth>
                      } />

                      <Route path='/prets/simulation/print' element={
                        <RequireAuth loginPath={'/Login'} >
                          <PrintTabAmort />
                        </RequireAuth>
                      } />
                    </>
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/backoffice/validation")) ?

                    <Route path='/backoffice/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValideOperation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/systeme/utilisateur")) ?

                    <Route path='/systeme/utilisateur' element={
                      <RequireAuth loginPath={'/Login'} >
                        <User />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {menus.find((e => e.lien == "/systeme/profilutilisateur")) ?
                    <Route path='/systeme/profilutilisateur' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Groupe />
                        {/* <CreateRoleForm /> */}
                        {/* <GroupUser22Page /> */}

                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/garanties/creation")) ?
                    <Route path='/garanties/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Garantie />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/garanties/validation")) ?
                    <Route path='/garanties/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidationGarantie />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/client/moral")) ?
                    <Route path='/client/moral' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClientMoral />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/prets/demande")) ?
                    <Route path='/prets/demande' element={
                      <RequireAuth loginPath={'/Login'} >
                        <DemandePret />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/backoffice/importexcellocale")) ?
                    <Route path='/backoffice/importexcellocale' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ImportSaisie />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/backoffice/importationinteragence")) ?
                    <Route path='/backoffice/importationinteragence' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ImportSaisieDistant />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/backoffice/extourne")) ?
                    <Route path='/backoffice/extourne' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Extourne />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/backoffice/importexcellocale")) ?
                    <Route path='/backoffice/importexcellocale' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ImportSaisie />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/prets/propostion")) ?
                    <Route path='/prets/propostion' element={
                      <RequireAuth loginPath={'/Login'} >
                        <PropositionPret />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/prets/validation")) ?
                    <Route path='/prets/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidationPret />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/prets/decaissement")) ?
                    <Route path='/prets/decaissement' element={
                      <RequireAuth loginPath={'/Login'} >
                        <DecaissementPret />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/prets/anticipation")) ?
                    <Route path='/prets/anticipation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AnticipationPret />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/prets/declassement")) ?
                    <Route path='/prets/declassement' element={
                      <RequireAuth loginPath={'/Login'} >
                        <DeclassementPret />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/garanties/creation")) ?
                    <Route path='/garanties/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Garantie />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/client/moral")) ?
                    <Route path='/client/moral' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClientMoral />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/situationclient/vu360")) ?
                    <>
                      <Route path='/situationclient/vu360/print/AvisOpération' element={
                        <RequireAuth loginPath={'/Login'} >
                          <PrintAvisOp />
                        </RequireAuth>}
                      />


                      <Route path='/situationclient/vu360/print/Schemacomptable' element={
                        <RequireAuth loginPath={'/Login'} >
                          <PrintShemaComptable />
                        </RequireAuth>}
                      />

                      <Route path='/situationclient/vu360' element={
                        <RequireAuth loginPath={'/Login'} >
                          <SituationCLient />
                        </RequireAuth>
                      } />
                      <Route path='/situationclient/vu360/:id' element={
                        <RequireAuth loginPath={'/Login'} >
                          <SituationCLient />
                        </RequireAuth>
                      } />
                      <Route path='/situationclient/vu360/print/HistoriqueCpt' element={
                        <RequireAuth loginPath={'/Login'} >
                          <PrintHistoCpt />
                        </RequireAuth>
                      } />
                    </>
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/avaliste/creation")) ?
                    <Route path='/avaliste/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Avaliste />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/systeme/ouverture")) ?
                    <Route path='/systeme/ouverture' element={
                      <RequireAuth loginPath={'/Login'} >
                        <OpenDay />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* Transfert Counter Compte à compte */}
                  {menus.find((e => e.lien == "/backoffice/virementlocal")) ?
                    <Route path='/backoffice/virementlocal' element={
                      <RequireAuth loginPath={'/Login'} >
                        <TransfertCptToCpt />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/backoffice/virementinteragence")) ?
                    <Route path='/backoffice/virementinteragence' element={
                      <RequireAuth loginPath={'/Login'} >
                        <TransfertCptToCptDistant />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* Transfert Counter Compte à compte */}
                  {menus.find((e => e.lien == "/caisse/veresmentretrait")) ?
                    <>
                      <Route path='/caisse/veresmentretrait/print' element={
                        <RequireAuth loginPath={'/Login'} >
                          <PrintRecu />
                        </RequireAuth>
                      } />
                      <Route path='/caisse/veresmentretrait' element={
                        <RequireAuth loginPath={'/Login'} >
                          <VersementEspece />
                        </RequireAuth>
                      } />
                    </>
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/systemecaisse/ouverture")) ?
                    <>
                      <Route path='/systemecaisse/ouverture/print' element={
                        <RequireAuth loginPath={'/Login'} >
                          <PrintClotureSystemCaisse />
                        </RequireAuth>}
                      />
                      <Route path='/systemecaisse/ouverture' element={
                        <RequireAuth loginPath={'/Login'} >
                          <ManageSystemeCaisse />
                        </RequireAuth>
                      } />
                    </>
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/systemecaisse/fermeture")) ?
                    <>
                      <Route path='/systemecaisse/fermeture/print' element={
                        <RequireAuth loginPath={'/Login'} >
                          <PrintClotureSystemCaisse />
                        </RequireAuth>}
                      />
                      <Route path='/systemecaisse/fermeture' element={
                        <RequireAuth loginPath={'/Login'} >
                          <ManageSystemeCaisse />
                        </RequireAuth>
                      } />
                    </>
                    :
                    ""
                  }



                  {/* Saisie Back-office */}
                  {menus.find((e => e.lien == "/remisecheque/saisie")) ?
                    <Route path='/remisecheque/saisie' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Saisie />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }



                  {/* Remise cheque à la banque  */}
                  {menus.find((e => e.lien == "/remisecheque/remisbanque")) ?
                    <Route path='/remisecheque/remisbanque' element={
                      <RequireAuth loginPath={'/Login'} >
                        <RemiseBank />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {/* Retour du cheque de la banque  */}
                  {menus.find((e => e.lien == "/remisecheque/retourbanque")) ?
                    <Route path='/remisecheque/retourbanque' element={
                      <RequireAuth loginPath={'/Login'} >
                        <BackToBank />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {/* EstCompte chèque Saisi cheque à la banque  */}
                  {menus.find((e => e.lien == "/remisecheque/escompte")) ?
                    <Route path='/remisecheque/escompte' element={
                      <RequireAuth loginPath={'/Login'} >
                        <EstCompte />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* EstCompte chèque Saisi cheque à la banque  */}
                  {menus.find((e => e.lien == "/bondecaisse/simulation")) ?
                    <Route path='/bondecaisse/simulation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <SimulationBDC2List />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* EstCompte chèque Saisi cheque à la banque  */}
                  {menus.find((e => e.lien == "/bondecaisse/creation")) ?
                    <Route path='/bondecaisse/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CreationBDC />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {/* EstCompte chèque Saisi cheque à la banque  */}
                  {menus.find((e => e.lien == "/bondecaisse/validation")) ?
                    <Route path='/bondecaisse/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidationBDC />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* EstCompte chèque Saisi cheque à la banque  */}
                  {menus.find((e => e.lien == "/bondecaisse/visualisation")) ?
                    <Route path='/bondecaisse/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualisationBDC />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* EstCompte chèque Saisi cheque à la banque  */}
                  {menus.find((e => e.lien == "/bondecaisse/anticipation")) ?
                    <Route path='/bondecaisse/anticipation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AnticipationBDC />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {/*Avoir les commissions et interets pour calcul fin du mois   */}
                  {menus.find((e => e.lien == "/businessmensuel/calculagios")) ?
                    <Route path='/businessmensuel/calculagios' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CalInteret />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/*Imputation des interets à la fin du mois */}
                  {menus.find((e => e.lien == "/businessmensuel/imputationagios")) ?
                    <Route path='/businessmensuel/imputationagios' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ImputInteret />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/systeme/fermeture")) ?
                    <Route path='/systeme/fermeture' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CloseDay />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  
                  {menus.find((e => e.lien == "/closing/batch")) ?
                    <Route path='/closing/batch' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClosingBatch />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  

                  {menus.find((e => e.lien == "/backoffice/saisielocal")) ?
                    <Route path='/backoffice/saisielocal' element={
                      <RequireAuth loginPath={'/Login'} >
                        <BackOffice />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {menus.find((e => e.lien == "/backoffice/saisieinteragence")) ?
                    <Route path='/backoffice/saisieinteragence' element={
                      <RequireAuth loginPath={'/Login'} >
                        <BackOfficeInterAgence />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* OPERATIONS DE CAISSE */}
                  {menus.find((e => e.lien == "/caisse/ouverturefermeture")) ?
                    <>
                      <Route path='/caisse/ouverturefermeture' element={
                        <RequireAuth loginPath={'/Login'} >
                          <OuvertureFermetureCaisse />
                        </RequireAuth>
                      } />

                      <Route path='caisse/ouverturefermeture/print' element={
                        <RequireAuth loginPath={'/Login'} >
                          <PrintEtatCaisse />
                        </RequireAuth>
                      } />
                    </>
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/caisse/echangemanuel")) ?
                    <Route path='/caisse/echangemanuel' element={
                      <RequireAuth loginPath={'/Login'} >
                        <EchangeManuelleCaisse />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/caisse/validation")) ?
                    <Route path='/caisse/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidationOperation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/caisse/validation")) ?
                    <Route path='/caisse/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidationOperation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  <Route path='/operation/reimpressionRecu' element={
                    <RequireAuth loginPath={'/Login'} >
                      <ReimpressionRecu />
                    </RequireAuth>
                  } />

                  {menus.find((e => e.lien == "/caisse/intercaisse")) ?
                    <Route path='/caisse/intercaisse' element={
                      <RequireAuth loginPath={'/Login'} >
                        <EmissionReceptionFond />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/caisse/arrete")) ?
                    <Route path='/caisse/arrete' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ArreterCaisse />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {menus.find((e => e.lien == "/caisse/arrete")) ?
                    <Route path='/caisse/arrete' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ArreterCaisse />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/transaction/brouillardJour")) ?
                    <Route path='/transaction/brouillardJour' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ListingCaisse />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/transaction/Litigecaisse")) ?
                    <Route path='/transaction/Litigecaisse' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ListingLitigeCaisse />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/transaction/AccountedOperations")) ?
                    <Route path='/transaction/AccountedOperations' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ListComptabilise />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }




                  {menus.find((e => e.lien == "/transaction/UnaccountedOperations")) ?
                    <Route path='//transaction/UnaccountedOperations' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ListNonComptabilise />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }



                  {menus.find((e => e.lien == "/relation/creation")) ?
                    <Route path='/relation/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Relation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {menus.find((e => e.lien == "/procuration/creation")) ?
                    <Route path='/procuration/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Procuration />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/compte/Operation")) ?
                    <Route path='/compte/Operation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CompteOrd />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/client/gl")) ?
                    <Route path='/client/gl' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClientInterne />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/client/phisique")) ?
                    <Route path='/client/phisique' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClientPhys />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/client/validation/phy")) ?
                    <Route path='/client/validation/phy' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VClientPhysique />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/client/validation/clm")) ?
                    <Route path='/client/validation/clm' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VClientMoral />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/businessmensuel/controlcompte")) ?
                    <Route path='/businessmensuel/controlcompte' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ControlCpt />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/compte/conditionspeciale")) ?
                    <Route path='/compte/conditionspeciale' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ControlCpt />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/document/demande")) ?
                    <Route path='/document/demande' element={
                      <RequireAuth loginPath={'/Login'} >
                        {/* <DocumentCleint /> */}
                        <Document />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/compte/engagement")) ?
                    <Route path='/compte/engagement' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CompteE />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/client/moral")) ?
                    <Route path='/client/moral' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClientMoral />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/compte/grandlivre")) ?
                    <Route path='/compte/grandlivre' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CompteGl />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/decouvert/creation")) ?
                    <Route path='/decouvert/creation' element={

                      <AddAutorisation />
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/decouvert/annulation")) ?
                    <Route path='/decouvert/annulation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <InvalidAutorisation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/decouvert/validation")) ?
                    <Route path='/decouvert/validation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidAutor />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/facility/Historisation")) ?
                    <Route path='/facility/Historisation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <HistoAutorisation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/decouvert/visualisation")) ?
                    <Route path='/decouvert/visualisation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualAutor />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/limite/creation")) ?
                    <Route path='/limite/creation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AddLimite />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/gelcompte/creation")) ?
                    <Route path='/gelcompte/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AddBlocage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/gelcompte/validation")) ?
                    <Route path='/gelcompte/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidBlocage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/gelcompte/annulation")) ?
                    <Route path='/gelcompte/annulation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AnnulBlocage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/gelcompte/visualisation")) ?
                    <Route path='/gelcompte/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualBlocage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/decouvert/creation")) ?
                    <Route path='/decouvert/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AddAutorisation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/decouvert/annulation")) ?
                    <Route path='/decouvert/annulation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <InvalidAutorisation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/decouvert/validation")) ?
                    <Route path='/decouvert/validation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidAutor />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/facility/Historisation")) ?
                    <Route path='/facility/Historisation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <HistoAutorisation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/decouvert/visualisation")) ?
                    <Route path='/decouvert/visualisation/*' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualAutor />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/gelcompte/creation")) ?
                    <Route path='/gelcompte/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AddBlocage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/gelcompte/validation")) ?
                    <Route path='/gelcompte/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidBlocage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/gelcompte/annulation")) ?
                    <Route path='/gelcompte/annulation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AnnulBlocage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/gelcompte/visualisation")) ?
                    <Route path='/gelcompte/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualBlocage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/chequier/demande")) ?
                    <Route path='/chequier/demande' element={
                      <RequireAuth loginPath={'/Login'} >
                        <DemandCHQ />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/chequier/miseenplace")) ?
                    <Route path='/chequier/miseenplace' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CreateCHQ />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/chequier/validation")) ?
                    <Route path='/chequier/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidCheque />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/chequier/oposition")) ?
                    <Route path='/chequier/oposition' element={
                      <RequireAuth loginPath={'/Login'} >
                        <OppositionCheque />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/chequier/oposition/annulation")) ?
                    <Route path='/chequier/oposition/annulation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AnnulOpposition />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/chequier/visualisation")) ?
                    <Route path='/chequier/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualCheque />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {/* //configuration profileclient */}

                  {menus.find((e => e.lien == "/profilclient/pays")) ?
                    <Route path='/profilclient/pays' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'PAYS'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/profilclient/region")) ?
                    <Route path='/profilclient/region' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'REGION'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/profilclient/ville")) ?
                    <Route path='/profilclient/ville' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'VILLE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/departement")) ?
                    <Route path='/profilclient/departement' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'DEPARTEMENT'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/residence")) ?
                    <Route path='/profilclient/residence' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'RESIDENCE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/zonegeographique")) ?
                    <Route path='/profilclient/zonegeographique' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'ZONEGEOGRAPHYQUE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/classerisque")) ?
                    <Route path='/profilclient/classerisque' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'CLASSERISQUE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/calsseage")) ?
                    <Route path='/profilclient/calsseage' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'CLASSEAGE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }



                  {menus.find((e => e.lien == "/profilclient/activite")) ?
                    <Route path='/profilclient/activite' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'ACTIVITE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/niveauetude")) ?
                    <Route path='/profilclient/niveauetude' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'NIVEAUETUDE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/classeintitutionnelle")) ?
                    <Route path='/profilclient/classeintitutionnelle' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'UNITEINSTITUTIONNELLE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/categorieclient")) ?
                    <Route path='/profilclient/categorieclient' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'CATCLI'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {menus.find((e => e.lien == "/profilclient/regimematrimonial")) ?
                    <Route path='/profilclient/regimematrimonial' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'REGMAT'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/formejuridique")) ?
                    <Route path='/profilclient/formejuridique' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'FORMEJURIDIQUE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/profession")) ?
                    <Route path='/profilclient/profession' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'PROFESSION'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/groupeclient")) ?
                    <Route path='/profilclient/groupeclient' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'GROUPECLIENT'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/titreclient")) ?
                    <Route path='/profilclient/titreclient' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'TITRESCLIENT'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/profilclient/ethnie")) ?
                    <Route path='/profilclient/ethnie' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'ETHNIE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/typeclient")) ?
                    <Route path='/profilclient/typeclient' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'TYPCLI'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/genre")) ?
                    <Route path='/profilclient/genre' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'CLSEXE'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilclient/filiataion")) ?
                    <Route path='/profilclient/filiataion' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri={'FILIA'} />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }





                  {/* {menus.find((e => e.lien == "/virementpermenant/creation")) ?
                    <Route path='/virementpermenant/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AddVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/visualisation")) ?
                    <Route path='/virementpermenant/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/validation")) ?
                    <Route path='/virementpermenant/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidEInvalidVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/annulation")) ?
                    <Route path='/virementpermenant/annulation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClotureVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/permanentTransfers/Oppose")) ?
                    <Route path='/permanentTransfers/Oppose' element={
                      <RequireAuth loginPath={'/Login'} >
                        <OpposeVP />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {/* {menus.find((e => e.lien == "/virementpermenant/creation")) ?
                    <Route path='/virementpermenant/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AddVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/visualisation")) ?
                    <Route path='/virementpermenant/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/validation")) ?
                    <Route path='/virementpermenant/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidEInvalidVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/annulation")) ?
                    <Route path='/virementpermenant/annulation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClotureVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/permanentTransfers/Oppose")) ?
                    <Route path='/permanentTransfers/Oppose' element={
                      <RequireAuth loginPath={'/Login'} >
                        <OpposeVP />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {/* {menus.find((e => e.lien == "/virementpermenant/creation")) ?
                    <Route path='/virementpermenant/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AddVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/visualisation")) ?
                    <Route path='/virementpermenant/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/validation")) ?
                    <Route path='/virementpermenant/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidEInvalidVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/annulation")) ?
                    <Route path='/virementpermenant/annulation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClotureVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/permanentTransfers/Oppose")) ?
                    <Route path='/permanentTransfers/Oppose' element={
                      <RequireAuth loginPath={'/Login'} >
                        <OpposeVP />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {menus.find((e => e.lien == "/virementpermenant/creation")) ?
                    <Route path='/virementpermenant/creation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <AddVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/virementpermenant/visualisation")) ?
                    <Route path='/virementpermenant/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* {menus.find((e => e.lien == "/virementpermenant/validation")) ?
                    <Route path='/virementpermenant/validation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ValidEInvalidVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {/* {menus.find((e => e.lien == "/virementpermenant/annulation")) ?
                    <Route path='/virementpermenant/annulation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ClotureVp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {menus.find((e => e.lien == "/permanentTransfers/Oppose")) ?
                    <Route path='/permanentTransfers/Oppose' element={
                      <RequireAuth loginPath={'/Login'} >
                        <OpposeVP />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* {menus.find((e => e.lien == "/Calculinteret/PrintINTDEB")) ?
                    <Route path='/Calculinteret/PrintINTDEB' element={
                      <RequireAuth loginPath={'/Login'} >
                        <PrintINTDEB />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {menus.find((e => e.lien == "/profilgestion/plancomptable")) ?
                    <Route path='/profilgestion/plancomptable' element={
                      <RequireAuth loginPath={'/Login'} >
                        <PlanCp />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/profilgestion/plancomptablebatch")) ?
                    <Route path='/profilgestion/plancomptablebatch' element={
                      <RequireAuth loginPath={'/Login'} >
                        <PlanCpBatch />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/profilgestion/bondecaisse")) ?
                    <Route path='/profilgestion/bondecaisse' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParamBDC />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {menus.find((e => e.lien == "/profilgestion/commissioninterets")) ?
                    <Route path='/profilgestion/commissioninterets' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Commis />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilgestion/codearreté")) ?
                    <Route path='/profilgestion/codearreté' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='ARRETECOMPTE' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilgestion/periodecomptable")) ?
                    <Route path='/profilgestion/periodecomptable' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='PERIOD' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilgestion/objetprets")) ?
                    <Route path='/profilgestion/objetprets' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='MOTIFPRET' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilgestion/dureeprets")) ?
                    <Route path='/profilgestion/dureeprets' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='DUREEPRET' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/profilgestion/libelleprets")) ?
                    <Route path='/profilgestion/libelleprets' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='LIBELLEPRET' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilgestion/etatcompte")) ?
                    <Route path='/profilgestion/etatcompte' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='ARRETECOMPTE' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilgestion/gestionnaire")) ?
                    <Route path='/profilgestion/gestionnaire' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='GESTIONNAIRE' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilgestion/demarcheur")) ?
                    <Route path='/profilgestion/demarcheur' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='DEMARCHEUR' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/profilgestion/devise")) ?
                    <Route path='/profilgestion/devise' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='DEVISE' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }



                  {menus.find((e => e.lien == "/profilgestion/caisse")) ?
                    <Route path='/profilgestion/caisse' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CreateCaisse />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/jourferier' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CreateFerier />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/jourferier' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CreateFerier />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/typecompte' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='TYPCPT' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/Categoriecompte' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='CATEGOCPT' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/bondecaisse' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='BONDECAISSE' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/decouvert' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='DECOUVERT' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/garantie' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='TYPEGARANTIE' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/document' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='TYPPIECE' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/cheque' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='TYPCHQ' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/formatcompte' element={
                      <RequireAuth loginPath={'/Login'} >
                        <FormatCompte1 />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "")) ?
                    <Route path='/profilgestion/formatsms' element={
                      <RequireAuth loginPath={'/Login'} >
                        <FormatSMSManage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/*
                   {menus.find((e => e.lien == "/profilclient/ville")) ?
                    <Route path='/profilclient/ville' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CreateVille />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {menus.find((e => e.lien == "/profilgestion/banque")) ?
                    <Route path='/profilgestion/banque' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CreateBank />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                   {menus.find((e => e.lien == "/profilgestion/categorieActif")) ?
                    <Route path='/profilgestion/categorieActif' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CategorieActifPage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                

                  
                  
                  {menus.find((e => e.lien == "/profilgestion/PointStockage")) ?
                    <Route path='/profilgestion/PointStockage' element={
                      <RequireAuth loginPath={'/Login'} >
                        <PointStockagePage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }



                  {menus.find((e => e.lien == "/financement/Journal")) ?
                    <Route path='/financement/Journal' element={
                      <RequireAuth loginPath={'/Login'} >
                        <JournalFinancementPage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                  {menus.find((e => e.lien == "/profilgestion/fournisseur")) ?
                    <Route path='/profilgestion/fournisseur' element={
                      <RequireAuth loginPath={'/Login'} >
                        <FournisseurPage />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  

                  {menus.find((e => e.lien == "/GestionBudget")) ?
                    <Route path='/GestionBudget' element={
                      <RequireAuth loginPath={'/Login'} >
                        <GestionBudget />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* {menus.find((e => e.lien == "/statistics")) ?
                    <Route path='/statistics' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Rapports />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}
                  {/* {menus.find((e => e.lien == "/profilgestion/service")) ?
                    <Route path='/profilgestion/service' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CreateService />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {menus.find((e => e.lien == "/profilgestion/service")) ?
                    <Route path='/profilgestion/service' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ParametreClient Rubri='TYPESERVICE' />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/systeme/agence")) ?
                    <Route path='/systeme/agence' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Agence />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/OperaSysteme")) ?
                    <Route path='/OperaSysteme' element={
                      <RequireAuth loginPath={'/Login'} >
                        <OperaSysteme />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {/* {menus.find((e => e.lien == "/profilgestion/Interfacecomptegl")) ?
                    <Route path='/profilgestion/Interfacecomptegl' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CompteRegroup />
                      </RequireAuth>
                    } />
                    :
                    ""
                  } */}

                  {menus.find((e => e.lien == "/interfacecompte/compteregroupement")) ?
                    <Route path='/interfacecompte/compteregroupement' element={
                      <RequireAuth loginPath={'/Login'} >
                        <CompteRegroup />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/interfacecompte/interetsetcommission")) ?
                    <Route path='/interfacecompte/interetsetcommission' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ComptesCommis />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/interfacecompte/operationsysteme")) ?
                    <Route path='/interfacecompte/operationsysteme' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ComptesOperatSysteme />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  {menus.find((e => e.lien == "/interfacecompte/Pretsetdecouvert")) ?
                    <Route path='/interfacecompte/Pretsetdecouvert' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ComptesPretEtDecouvert />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/profilgestion/operationsysteme")) ?
                    <Route path='/profilgestion/operationsysteme' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Operation />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/transaction/Counted")) ?
                    <Route path='/transaction/Counted' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ListComptabilise />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/limite/visualisation")) ?
                    <Route path='/limite/visualisation' element={
                      <RequireAuth loginPath={'/Login'} >
                        <VisualLimite />
                      </RequireAuth>
                    } />
                    :

                    ""
                  }

                  {menus.find((e => e.lien == "/transaction/historicial/0")) ?
                    <Route path='/transaction/historicial/:id' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Historique />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }
                  
                  {menus.find((e => e.lien == "/fonctionnalite")) ?
                    <Route path='/fonctionnalite' element={
                      <RequireAuth loginPath={'/Login'} >
                        <Fonctionnalite />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }

                  {menus.find((e => e.lien == "/pcemf-import")) ?
                    <Route path='/pcemf-import' element={
                      <RequireAuth loginPath={'/Login'} >
                        <ImportPCEMF />
                      </RequireAuth>
                    } />
                    :
                    ""
                  }


                </>
                :
                ""
            }


            <Route path='*' element={
              <RequireAuth loginPath={'/Login'} >
                <PageNotFound />
              </RequireAuth>
            } />

            <Route path='/SituationClient/print/Schemacomptable' element={
              <RequireAuth loginPath={'/Login'} >
                <PrintShemaComptable />
              </RequireAuth>}
            />

            <Route path='Calculinteret/PrintINTDEB' element={
              <RequireAuth loginPath={'/Login'} >
                <PrintINTDEB />
              </RequireAuth>}
            />
            <Route path='/transaction/brouillardJour/PrintListOpeCait' element={
              <RequireAuth loginPath={'/Login'} >
                <PrintListOpeCai />
              </RequireAuth>}
            />


            <Route path='/avaliste/creation' element={
              <RequireAuth loginPath={'/Login'} >
                <Avaliste />
              </RequireAuth>
            } />
            <Route path='*' element={
              <RequireAuth loginPath={'/Login'} >
                <PageNotFound />
              </RequireAuth>
            } />


            <Route path='/transaction/print' element={
              <RequireAuth loginPath={'/Login'} >
                <PrintListOpeCm />
              </RequireAuth>
            } />

            <Route path='/SituationClient/:id' element={
              <RequireAuth loginPath={'/Login'} >
                <SituationCLient />
              </RequireAuth>
            } />

            <Route path='/SituationClient/print/HistoriqueCpt' element={
              <RequireAuth loginPath={'/Login'} >
                <PrintHistoCpt />
              </RequireAuth>
            } />

            {/* Ouverture de Journée */}
            <Route path='/business/opening' element={
              <RequireAuth loginPath={'/Login'} >
                <OpenDay />
              </RequireAuth>
            } />


            <Route path='/avaliste/creation' element={
              <RequireAuth loginPath={'/Login'} >
                <Avaliste />
              </RequireAuth>
            } />


            {/* Transfert Counter Compte à compte */}
            <Route path='/backoffice/virementcptacpt' element={
              <RequireAuth loginPath={'/Login'} >
                <TransfertCptToCpt />
              </RequireAuth>
            } />

            {/* Transfert Counter Compte à compte */}
            <Route path='/caisse/veresmentretrait/print' element={
              <RequireAuth loginPath={'/Login'} >
                <PrintRecu />
              </RequireAuth>
            } />

            {/* Transfert Counter Compte à compte */}
            <Route path='/caisse/veresmentretrait/print' element={
              <RequireAuth loginPath={'/Login'} >
                <PrintRecu />
              </RequireAuth>
            } />

            {/* Liste client */}
            <Route path='/Rapport/listedeslients' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFastReport Entete='Liste des clients ouverts' Type='All' />
              </RequireAuth>
            } />

            {/*  client relation */}
            <Route path='/Rapport/listedeslientsrelations' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFastReport Entete='Liste des clients et relations' Type='Relation' />
              </RequireAuth>
            } />

            {/*  client limite */}
            <Route path='/Rapport/listedesclientslimites' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFastReport Entete='Liste des clients et limite' Type='Limite' />
              </RequireAuth>
            } />

            {/*  client montant bloque */}
            <Route path='/Rapport/listedesclientsbloques' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFastReport Entete='Liste des clients et montants bloques' Type='Bloque' />
              </RequireAuth>
            } />

            {/*  client montant decouvert */}
            <Route path='/Rapport/listedesclientsdecouverts' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFastReport Entete='Liste des clients et découvert' Type='Decouvert' />
              </RequireAuth>
            } />

            {/*  client et compte */}
            <Route path='/Rapport/listedesclientscomptes' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFastReport Entete='Liste des clients et compte' Type='Compte' />
              </RequireAuth>
            } />

            {/*  client et prets */}
            <Route path='/Rapport/listedesclientsprets' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFastReport Entete='Liste des clients et prets' Type='Pret' />
              </RequireAuth>
            } />

            {/*  client procuration */}
            <Route path='/Rapport/listedesclientsprocurations' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFastReport Entete='Liste des clients et limite' Type='Limite' />
              </RequireAuth>
            } />

            {/*  client activité economique */}
            <Route path='/Rapport/clientgroupeactivie' element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par activité economique' TypeGroup='Activite' />
              </RequireAuth>
            } />

            <Route path="/Rapport/clientgroupeethnie" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par ethnie' TypeGroup='Ethnie' />
              </RequireAuth>

            } />
            <Route path="/Rapport/clientgroupeanneenais" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par année naissance' TypeGroup='Annee' />
              </RequireAuth>
            } />

            <Route path="/Rapport/clientgroupegenre" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par genre' TypeGroup='Genre' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgroupenivinstruction" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par instruction' TypeGroup='Instruction' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgroupemoisnais" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par mois naissance' TypeGroup='Mois' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgroupeprofession" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par profession' TypeGroup='Profession' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgrouperegimemat" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par regime matrimonial' TypeGroup='Regmat' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgroupesituationfam" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par situation familliale' TypeGroup='Sitfam' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgroupetrancheage" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par tranche age' TypeGroup='Trancheage' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgroupetypecli" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par type client' TypeGroup='Typecli' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgroupeutilisateur" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par utilisateur' TypeGroup='User' />
              </RequireAuth>
            } />
            <Route path="/Rapport/clientgroupeinstitution" element={
              <RequireAuth loginPath={'/Login'} >
                <ListClientFRGroupe Entete='Liste des clients par institution' TypeGroup='Institution' />
              </RequireAuth>
            } />

            {/* module compte */}
            <Route path="/Rapport/modulecomptes/compteplan" element={
              <RequireAuth loginPath={'/Login'} >
                <ListCompteFRGroupe Entete='Liste des comptes par plan comptable' TypeGroup='Plancomptable' />
              </RequireAuth>
            } />
            <Route path="/Rapport/modulecomptes/comptegestionnaire" element={
              <RequireAuth loginPath={'/Login'} >
                <ListCompteFRGroupe Entete='Liste des comptes par gestionnaire' TypeGroup='gestionnaire' />
              </RequireAuth>
            } />
            <Route path="/Rapport/modulecomptes/compteutilisateur" element={
              <RequireAuth loginPath={'/Login'} >
                <ListCompteFRGroupe Entete='Liste des comptes par utilisateur' TypeGroup='utilisateur' />
              </RequireAuth>
            } />
            <Route path="/Rapport/modulecomptes/comptebloque" element={
              <RequireAuth loginPath={'/Login'} >
                <ListCompteFRGroupe Entete='Liste des comptes bloque' TypeGroup='Bloque' />
              </RequireAuth>
            } />
            <Route path="/Rapport/modulecomptes/comptedecouvert" element={
              <RequireAuth loginPath={'/Login'} >
                <ListCompteFRGroupe Entete='Liste des comptes decouvert' TypeGroup='Decouvert' />
              </RequireAuth>
            } />
            <Route path="/Rapport/modulecomptes/comptelimite" element={
              <RequireAuth loginPath={'/Login'} >
                <ListCompteFRGroupe Entete='Liste des limites comptes' TypeGroup='limite' />
              </RequireAuth>
            } />

            {/* transaction caisse */}
            <Route path="/Rapport/moduletransactions/historiquecompte" element={
              <RequireAuth loginPath={'/Login'} >
                <FRHistoCompte Entete='Historique de compte' TypeGroup='Historique' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduletransactions/litigecaisse" element={
              <RequireAuth loginPath={'/Login'} >
                <FRTransactionCaisse Entete='Listing des litiges caisse' TypeGroup='Litigecaisse' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduletransactions/listingcaisse" element={
              <RequireAuth loginPath={'/Login'} >
                <FRTransactionCaisse Entete='Listing des transactions caisse' TypeGroup='Listingcaisse' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduletransactions/listingbackoffice" element={
              <RequireAuth loginPath={'/Login'} >
                <FRTransactionBackOffice Entete='Listing des transactions backoffice' TypeGroup='Listingbackoffice' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduletransactions/listingparlot" element={
              <RequireAuth loginPath={'/Login'} >
                <FRTransactionByRef Entete='Listing des transactions par lot' Type='Pret' />
              </RequireAuth>
            } />

            {/* module prets */}

            <Route path="/Rapport/moduleprets/demandeencours" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des demande de prets' TypeGroup='demandeprets' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/pretpartype" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des prets validés par type' TypeGroup='pretpartype' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/pretpargestionnaire" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des prets validés par gestionnaire' TypeGroup='pretpargestionnaire' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/pretparmotif" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des prets validés par motif' TypeGroup='pretparmotif' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/pratparactivite" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des prets validés par activité' TypeGroup='pretparactivite' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/pretpargenre" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des prets validés par genre (H/F/G)' TypeGroup='pretpargenre' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/pretparutilisateur" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des prets validés par utilisateur' TypeGroup='pretparutilisateur' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/pretparvalideur" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des prets validés par valideur' TypeGroup='pretparvalideur' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/previsionpret" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Liste des prévision de remboursement' TypeGroup='previsionpret' />
              </RequireAuth>
            } />

            <Route path="/Rapport/moduleprets/portefeuillesaint" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Portefeuille des prêts saints' TypeGroup='portefeuillesaint' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/portefeuilleimpaye" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Portefeuille des prêts impayés' TypeGroup='portefeuilleimpaye' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/encoursprets" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Encours des prêts' TypeGroup='encourspret' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/etatremoursementprets" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Etat de remboursement des prêts' TypeGroup='etatremboursementpret' />
              </RequireAuth>
            } />
            <Route path="/Rapport/moduleprets/etatpretechus" element={
              <RequireAuth loginPath={'/Login'} >
                <FRListingPret Entete='Etat des prêts echus' TypeGroup='etatpretechus' />
              </RequireAuth>
            } />
            

            {/* module finance */}

            <Route path="/Rapport/modulefinance/balancegenerale" element={
              <RequireAuth loginPath={'/Login'} >
                <FRBalanceCompte Entete='Balance générale des comptes' TypeGroup='balancegenerale' />
              </RequireAuth>
            } />
            <Route path="/Rapport/modulefinance/comptegestion" element={
              <RequireAuth loginPath={'/Login'} >
                <FRSoldeGestion Entete='Solde de gestion' TypeGroup='soldegestion' />
              </RequireAuth>
            } />
            <Route path="/Rapport/modulefinance/bilangenerale" element={
              <RequireAuth loginPath={'/Login'} >
                <FRBilanGeneral Entete='Bilan général' TypeGroup='bilangeneral' />
              </RequireAuth>
            } />
            
            <Route path="/config/billetage" element={
              <RequireAuth loginPath={'/Login'} >
                <BilletageConfig />
              </RequireAuth>
            } />


            {/* //PrintListOpeCm */}


            {/* <Route path='/virementpermenant/creation' element={<AddVp />} />
            <Route path='/virementpermenant/visualisation' element={<VisualVp />} />
           */}
            <Route path='/virementpermenant/validation' element={<ValidEInvalidVp />} />
            <Route path='/virementpermenant/annulation' element={<ClotureVp />} />
            {/* <Route path='/permanentTransfers/Oppose' element={<OpposeVP />} /> */}
            {/* <Route path='/virementpermenant/annulation' element={<Socity />} />       *soscity*           */}
            <Route path='/ParamSocity' element={<Socity />} />



              <Route path="profilgestion/typegarantie" element={
                        <RequireAuth loginPath={'/Login'} >
                          <Typegarantie/>
              </RequireAuth>
            } />


            {/* Provisoirrrrrrrrrrrrrrr */}
            {/* <Route path='/loan/declassement' element={
                <DeclassementPret />
            } />
            <Route path='/prets/anticipation' element={
                <AnticipationPret />
            } />
            <Route path='/prets/decaissement' element={
                <DecaissementPret />
            } />
            <Route path='/prets/validation' element={
                <ValidationPret />
            } />
            <Route path='/prets/propostion' element={
                <PropositionPret />
            } />
            <Route path='/prets/demande' element={
                <DemandePret />
            } />
            <Route path='/prets/simulation' element={
                <Simulation />
            } />

            <Route path='/prets/simulation/print' element={
                <PrintTabAmort />
            } /> */}

          </Routes>

          <p className='copyright'>{t("texte.copyright")}</p>
        </Box>
      </Box>
      <Box component="footer">

      </Box>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>



  );
}